import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import * as Common from 'common/components';
import { valueFromEvent } from 'lib/util';

class AssetsFormFilesPreviewRow extends PureComponent {
  static propTypes = {
    file: PropTypes.object.isRequired,
    handleRemove: PropTypes.func.isRequired,
    id: PropTypes.any.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleRemove = (e) => {
    e.preventDefault();
    this.props.handleRemove(this.props.id);
  };

  state = { preview: null };

  render = () => (
    <tr>
      <td className="text-center align-middle">
        <Common.FilePreview file={this.props.file.file} />
      </td>
      <td className="align-middle">{this.props.file.name}</td>
      <td className="align-middle text-center">
        {this.props.t(this.props.file.status)}
        <div className="progress">
          <div
            className="progress-bar"
            style={{
              width: `${this.props.file.percentage}%`,
            }}
          />
        </div>
      </td>
      <td className="align-middle text-center" />
      <td className="align-middle">
        <button className="btn btn-danger btn-sm" onClick={this.handleRemove}>
          {this.props.t('actions.delete')}
        </button>
      </td>
    </tr>
  );
}

export default translate()(AssetsFormFilesPreviewRow);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormFilesPreviewRow.js